import { ProductCard } from './ui/ProductCard.jsx'

export default ProductCard
